import { render, staticRenderFns } from "./GenerateForm.vue?vue&type=template&id=9f4a9470&"
import script from "./GenerateForm.vue?vue&type=script&lang=js&"
export * from "./GenerateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports